// @ts-nocheck
import { USER_DETAILS_ERROR, USER_DETAILS_LOADING, USER_DETAILS_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UserDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_DETAILS_LOADING:
            return Object.assign({}, state, { loading: true })
        case USER_DETAILS_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case USER_DETAILS_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

